import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';

import styles from './horizontal-container.css';

const { div } = hh(h);

const HorizontalContainer = (props) => div({className: styles.container}, props.children);

export default HorizontalContainer;



/** WEBPACK FOOTER **
 ** ./src/HorizontalContainer/index.js
 **/